import { provideHttpClient, withFetch } from '@angular/common/http';
import type { EnvironmentProviders, Provider } from '@angular/core';

export function provideEnvironmentSpecificProviders(): Array<EnvironmentProviders | Provider> {
    return [provideHttpClient(withFetch())];
}
